// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const brazier = defineModel({
  id: "brazier",
  batchId: "future",
  name: "Brazier",
  tags: ["scenery","brazier","low-poly","age-of-mcp","future"],
  summary: "A standing brazier — fire for light and warmth in the open.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.2,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.012, 0.016, 0.4, 5), color: "#33383d", position: [0.08, 0.2, 0], rotation: [0, 0, -0.35] },
      { geometry: new THREE.CylinderGeometry(0.012, 0.016, 0.4, 5), color: "#33383d", position: [-0.04, 0.2, 0.069282], rotation: [0.303109, 0, 0.175] },
      { geometry: new THREE.CylinderGeometry(0.012, 0.016, 0.4, 5), color: "#33383d", position: [-0.04, 0.2, -0.069282], rotation: [-0.303109, 0, 0.175] },
      { geometry: new THREE.TorusGeometry(0.07, 0.01, 4, 9), color: "#474d53", position: [0, 0.22, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.16, 0.09, 0.12, 10), color: "#33383d", position: [0, 0.42, 0] },
      { geometry: new THREE.TorusGeometry(0.155, 0.018, 4, 11), color: "#474d53", position: [0, 0.48, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.11, 0), color: "#c43a20", position: [0, 0.48, 0], scale: [1, 0.5, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#ff6a2a", position: [0.03, 0.51, -0.02] },
      { geometry: new THREE.ConeGeometry(0.09, 0.24, 7), color: "#ff9a32", position: [0, 0.64, 0] },
      { geometry: new THREE.ConeGeometry(0.05, 0.3, 6), color: "#ffd24a", position: [0.02, 0.7, 0.01] },
      { geometry: new THREE.ConeGeometry(0.04, 0.16, 5), color: "#ff9a32", position: [-0.05, 0.6, 0.03] },
    ],
  animations: [],
});
